export default __webpack_public_path__ + "static/media/conquerorhead.17073945.png";